
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { Canvas, Meta, Story } from '@storybook/addon-docs';
import contactFormDemo from './demo/contact-form/form.twig';
import contactFormSuccessDemo from './demo/contact-form/success.twig';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Meta title="Vendor/WordPress/Jetpack Blocks" mdxType="Meta" />
    <h1>{`Jetpack Blocks`}</h1>
    <p>{`WordPress developer Automattic provides a `}<a parentName="p" {...{
        "href": "https://jetpack.com/"
      }}>{`Jetpack`}</a>{` plugin that includes additional blocks. We support a selection of these.`}</p>
    <h2>{`Markdown Block`}</h2>
    <p>{`The markdown block applies vertical rhythm between its children. If contained within a `}<a parentName="p" {...{
        "href": "/docs/objects-rhythm--default-story"
      }}>{`Rhythm object`}</a>{`, the markdown block will inherit the same spacing. For example, if the Rhythm object uses the `}<inlineCode parentName="p">{`o-rhythm--generous`}</inlineCode>{` modifier, the markdown block will inherit the generous spacing.`}</p>
    <p>{`See also: `}<a parentName="p" {...{
        "href": "https://jetpack.com/support/markdown/"
      }}>{`Markdown Block documentation`}</a></p>
    <Canvas mdxType="Canvas">
  <Story name="Markdown" mdxType="Story">
    {`<div class="wp-block-jetpack-markdown">
      <p>
        <b>Lorem</b> <i>ipsum</i> dolor sit amet, consectetur adipiscing elit. Quisque eu ex
        enim. Nunc efficitur scelerisque dolor et sollicitudin.
      </p>
      <p>
        Donec finibus lorem elit, eu consectetur quam pellentesque sed.
        Pellentesque habitant morbi tristique senectus et netus et malesuada
        fames ac turpis egestas.
      </p>
    </div>`}
  </Story>
    </Canvas>
    <h2>{`Form Blocks`}</h2>
    <p>{`Jetpack includes `}<a parentName="p" {...{
        "href": "https://jetpack.com/support/jetpack-blocks/contact-form/"
      }}>{`a Form Block`}</a>{` which may be used to construct contact forms from various form field blocks.`}</p>
    <p>{`Our styles include customizations for some of these form elements, with some exceptions:`}</p>
    <ul>
      <li parentName="ul">{`We do not have a custom radio input style yet. For now, the default browser styles are used.`}</li>
      <li parentName="ul">{`We do not support Jetpack's style customizations. These would make forms feel inconsistent with the rest of our experience.`}</li>
      <li parentName="ul">{`We do not optimize our styles for Jetpack's jQuery UI enhancements, which we recommend `}<a parentName="li" {...{
          "href": "http://developer.wordpress.org/reference/functions/wp_dequeue_script/"
        }}>{`dequeuing`}</a>{` and/or `}<a parentName="li" {...{
          "href": "http://developer.wordpress.org/reference/functions/wp_deregister_script/"
        }}>{`deregistering`}</a>{` where possible for performance.`}</li>
    </ul>
    <Canvas mdxType="Canvas">
  <Story name="Contact Form" parameters={{
        layout: 'fullscreen'
      }} mdxType="Story">
    {contactFormDemo}
  </Story>
    </Canvas>
    <p>{`The success messaging markup generated by these blocks is pretty quirky, but we do our best to style it. Browsers that support `}<inlineCode parentName="p">{`:has`}</inlineCode>{` will hide any field summaries with empty values.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Contact Form Success" parameters={{
        layout: 'fullscreen'
      }} mdxType="Story">
    {contactFormSuccessDemo}
  </Story>
    </Canvas>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

export const markdown = () => (
          `<div class="wp-block-jetpack-markdown">
      <p>
        <b>Lorem</b> <i>ipsum</i> dolor sit amet, consectetur adipiscing elit. Quisque eu ex
        enim. Nunc efficitur scelerisque dolor et sollicitudin.
      </p>
      <p>
        Donec finibus lorem elit, eu consectetur quam pellentesque sed.
        Pellentesque habitant morbi tristique senectus et netus et malesuada
        fames ac turpis egestas.
      </p>
    </div>`
        );
markdown.storyName = 'Markdown';
markdown.parameters = { storySource: { source: '`<div class=\"wp-block-jetpack-markdown\">\n      <p>\n        <b>Lorem</b> <i>ipsum</i> dolor sit amet, consectetur adipiscing elit. Quisque eu ex\n        enim. Nunc efficitur scelerisque dolor et sollicitudin.\n      </p>\n      <p>\n        Donec finibus lorem elit, eu consectetur quam pellentesque sed.\n        Pellentesque habitant morbi tristique senectus et netus et malesuada\n        fames ac turpis egestas.\n      </p>\n    </div>`' } };

export const contactForm = assertIsFn(contactFormDemo);
contactForm.storyName = 'Contact Form';
contactForm.parameters = { storySource: { source: 'contactFormDemo' }, ...{
  layout: 'fullscreen'
} };

export const contactFormSuccess = assertIsFn(contactFormSuccessDemo);
contactFormSuccess.storyName = 'Contact Form Success';
contactFormSuccess.parameters = { storySource: { source: 'contactFormSuccessDemo' }, ...{
  layout: 'fullscreen'
} };

const componentMeta = { title: 'Vendor/WordPress/Jetpack Blocks', includeStories: ["markdown","contactForm","contactFormSuccess"],  };

const mdxStoryNameToKey = {"Markdown":"markdown","Contact Form":"contactForm","Contact Form Success":"contactFormSuccess"};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;